var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.mode === "DESIGN"
      ? _c(
          "div",
          [
            _c(
              "draggable",
              _vm._b(
                {
                  staticClass: "l-drag-from",
                  attrs: { list: _vm._columns, group: "form" },
                  on: {
                    start: function ($event) {
                      _vm.drag = true
                      _vm.selectFormItem = null
                    },
                    end: function ($event) {
                      _vm.drag = false
                    },
                  },
                },
                "draggable",
                { animation: 300, chosenClass: "choose", sort: true },
                false
              ),
              _vm._l(_vm._columns, function (cp, id) {
                return _c(
                  "div",
                  {
                    key: id,
                    staticClass: "l-form-item",
                    style: _vm.getSelectedClass(cp),
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectItem(cp)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "l-form-header" },
                      [
                        _c("p", [
                          cp.props.required
                            ? _c("span", [_vm._v("*")])
                            : _vm._e(),
                          _vm._v(_vm._s(cp.title)),
                        ]),
                        _c("div", { staticClass: "l-option" }, [
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                return _vm.delItem(id)
                              },
                            },
                          }),
                        ]),
                        _c("form-design-render", { attrs: { config: cp } }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                staticStyle: {
                  color: "#c0bebe",
                  "text-align": "center",
                  width: "90%",
                  padding: "5px",
                },
              },
              [_vm._v("☝ 拖拽控件到表格内部")]
            ),
          ],
          1
        )
      : _c("div", [
          _vm.rowLayout
            ? _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        size: "medium",
                        "header-cell-style": {
                          background: "#f5f7fa",
                          padding: "3px 0",
                        },
                        border: _vm.showBorder,
                        data: _vm._value,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          type: "index",
                          label: "序号",
                          width: "55",
                        },
                      }),
                      _vm._l(_vm._columns, function (column, index) {
                        return _c("el-table-column", {
                          key: index,
                          attrs: {
                            "min-width": _vm.getMinWidth(column),
                            prop: column.id,
                            label: column.title,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("form-design-render", {
                                      class: {
                                        "valid-error": _vm.showError(
                                          column,
                                          _vm._value[scope.$index][column.id]
                                        ),
                                      },
                                      attrs: {
                                        readerMode: _vm.readerMode,
                                        mode: _vm.mode,
                                        config: column,
                                      },
                                      model: {
                                        value:
                                          _vm._value[scope.$index][column.id],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm._value[scope.$index],
                                            column.id,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "_value[scope.$index][column.id]",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      !_vm.readerMode
                        ? _c("el-table-column", {
                            attrs: {
                              fixed: "right",
                              "min-width": "90",
                              label: "操作",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini", type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyData(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("复制")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini", type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.delRow(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3573095417
                            ),
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                  !_vm.readerMode
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-plus" },
                          on: { click: _vm.addRow },
                        },
                        [_vm._v(_vm._s(_vm.placeholder))]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm._l(_vm._value, function (row, i) {
                    return _c(
                      "el-form",
                      {
                        key: i,
                        ref: `table-form-${i}`,
                        refInFor: true,
                        staticClass: "table-column",
                        attrs: { rules: _vm.rules, model: row },
                      },
                      [
                        _c("div", { staticClass: "table-column-action" }, [
                          _c("span", [_vm._v("第 " + _vm._s(i + 1) + " 项")]),
                          !_vm.readerMode
                            ? _c("i", {
                                staticClass: "el-icon-close",
                                on: {
                                  click: function ($event) {
                                    return _vm.delRow(i, row)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._l(_vm._columns, function (column, index) {
                          return _c(
                            "el-form-item",
                            {
                              key: "column_" + index,
                              attrs: { prop: column.id, label: column.title },
                            },
                            [
                              _c("form-design-render", {
                                attrs: {
                                  readerMode: _vm.readerMode,
                                  mode: _vm.mode,
                                  config: column,
                                },
                                model: {
                                  value: row[column.id],
                                  callback: function ($$v) {
                                    _vm.$set(row, column.id, $$v)
                                  },
                                  expression: "row[column.id]",
                                },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    )
                  }),
                  !_vm.readerMode
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-plus" },
                          on: { click: _vm.addRow },
                        },
                        [_vm._v(_vm._s(_vm.placeholder))]
                      )
                    : _vm._e(),
                ],
                2
              ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }